var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorCircleCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 32,
    width: 32,
    overflow: "visible"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#ff3939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M24 10.1L21.9 8 16 13.9 10.1 8 8 10.1l5.9 5.9L8 21.9l2.1 2.1 5.9-5.9 5.9 5.9 2.1-2.1-5.9-5.9z"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiBoZWlnaHQ9IjMyIiBzdHlsZT0ib3ZlcmZsb3c6dmlzaWJsZTtlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDMyIDMyIiB2aWV3Qm94PSIwIDAgMzIgMzIiIHdpZHRoPSIzMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+PGc+PGcgaWQ9IkluY29ycmVjdF9TeW1ib2xfMV8iPjxnIGlkPSJJbmNvcnJlY3RfU3ltYm9sIj48Y2lyY2xlIGN4PSIxNiIgY3k9IjE2IiBpZD0iQkciIHI9IjE2IiBzdHlsZT0iZmlsbDojRkYzOTM5OyIvPjxwb2x5Z29uIGlkPSJDcm9zc194NUZfU3ltYm9sIiBwb2ludHM9IjI0LDEwLjEgMjEuOSw4IDE2LDEzLjkgMTAuMSw4IDgsMTAuMSAgICAgICAgIDEzLjksMTYgOCwyMS45IDEwLjEsMjQgMTYsMTguMSAyMS45LDI0IDI0LDIxLjkgMTguMSwxNiAiIHN0eWxlPSJmaWxsOiNFNkU2RTY7Ii8+PC9nPjwvZz48L2c+PC9zdmc+";
export { SvgErrorCircleCross as ReactComponent };